export default {
  Pretitle: `404 Pagina no encontrada`,
  Title: `¿Cuál es la ‘dillo?`,
  Subtitle: `La página que está buscando no está disponible.`,
};
